/**
 * Black Friday pages: things rise softly into place as they scroll into view, cascading inside a row (product cards,
 * category tiles, benefits, spec details). Loaded by snippets/bf-page-kit.liquid.
 * - Nothing is hidden without this script, nor for people who ask for reduced motion.
 * - What is already on screen when the page opens is shown at once (no flash, no delay of the first paint).
 * - Only opacity and transform move, so nothing shifts the layout.
 */
(function () {
  if (window.__bfMotion) return;
  window.__bfMotion = true;
  if (!("IntersectionObserver" in window)) return;
  if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  // Groups whose children cascade one after the other, and single blocks that rise on their own.
  var GROUPS = [".bf-prods__row", ".bf-cats__row", ".bf-benefits__row", ".bf-spec", ".bf-pdp-trust", ".bf-pr__list"];
  var SINGLES = [".bf-prods__head", ".bf-cats__head", ".bf-revs__head", ".bf-benefits__title", ".bf-banner__lead", ".bf-banner__side", ".bf-pr__summary", ".bf-revs__stage"];

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add("is-in");
      io.unobserve(e.target);
    });
  }, { rootMargin: "0px 0px -8% 0px", threshold: 0.12 });

  function inView(el) {
    var r = el.getBoundingClientRect();
    return r.top < window.innerHeight && r.bottom > 0;
  }

  function mark(el, i) {
    if (el._bfReveal) return;
    el._bfReveal = true;
    el.setAttribute("data-bf-reveal", "");
    el.style.setProperty("--bf-i", String(Math.min(i, 8)));
    if (inView(el)) el.classList.add("is-in");
    else io.observe(el);
  }

  function scan(root) {
    GROUPS.forEach(function (sel) {
      Array.prototype.forEach.call(root.querySelectorAll(sel), function (group) {
        Array.prototype.forEach.call(group.children, function (child, i) { mark(child, i % 4); });
      });
    });
    SINGLES.forEach(function (sel) {
      Array.prototype.forEach.call(root.querySelectorAll(sel), function (el) { mark(el, 0); });
    });
  }

  function init() {
    scan(document);
    document.documentElement.classList.add("bf-motion");
    // Rows shown later by "Încarcă mai multe" are display:none until then: the observer catches them when they appear.
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
  document.addEventListener("shopify:section:load", function (e) { scan(e.target); });
})();
